"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactHotkeys = require("react-hotkeys");

var _reactTooltip = _interopRequireDefault(require("react-tooltip"));

var _preloader = require("../../../helpers/preloader/preloader.effect");

var _videoControls = require("../video-controls.effect");

var _videoStates = _interopRequireDefault(require("../video-states"));

var _playerActionTypes = _interopRequireDefault(require("../player-action-types"));

const {
  PAUSED,
  PLAYING,
  ENDED
} = _videoStates.default;

const Playpause = ({
  videoTag,
  toggleOnVideoClick,
  callbacks,
  onShortcutChange,
  texts,
  hasToolTip
}) => {
  const {
    status
  } = (0, _videoControls.useVideoStatus)(videoTag);
  const updatedStatus = (0, _react.useRef)(status);
  (0, _react.useEffect)(() => {
    updatedStatus.current = status;

    if (toggleOnVideoClick) {
      videoTag.addEventListener('click', toggleByShortcut);
      videoTag.classList.add('clickable');
    }

    return () => {
      videoTag.removeEventListener('click', toggleByShortcut);
      videoTag.classList.remove('clickable');
    };
  }, [status, toggleOnVideoClick]);

  function toggleByShortcut() {
    toggle();

    if (updatedStatus.current === PLAYING) {
      onShortcutChange(_playerActionTypes.default.PAUSED);
    } else {
      onShortcutChange(_playerActionTypes.default.PLAYING);
    }
  }

  const tooltipMessages = {
    [PAUSED]: texts.play,
    [PLAYING]: texts.pause,
    [ENDED]: texts.replay
  };
  const [tooltipMessage, setTooltipMessage] = (0, _react.useState)();
  (0, _react.useEffect)(() => {
    setTooltipMessage(tooltipMessages[status]);
  }, [status]);

  function play() {
    videoTag.play();
  }

  function replay() {
    videoTag.currentTime = 0;
    play();
  }

  function pause() {
    videoTag.pause();
  }

  function toggle() {
    switch (updatedStatus.current) {
      case PLAYING:
        pause();
        break;

      case PAUSED:
        play();
        break;

      case ENDED:
        replay();
        break;
    }

    const {
      onPlaypause
    } = callbacks;

    if (onPlaypause) {
      onPlaypause(status);
    }
  }

  const control = (0, _react.useRef)(null);
  (0, _preloader.usePreloader)(control); // hotKeys

  const keyMap = {
    PLAY_PAUSE: ['space', 'k', 'K']
  };
  const handlers = {
    PLAY_PAUSE: event => {
      event.preventDefault();
      toggleByShortcut();
    }
  };
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactHotkeys.GlobalHotKeys, {
    keyMap: keyMap,
    handlers: handlers
  }), hasToolTip && /*#__PURE__*/_react.default.createElement(_reactTooltip.default, {
    id: "playpause-tooltip",
    class: "playpause__tooltip",
    effect: "solid",
    place: "top",
    getContent: () => tooltipMessage
  }), /*#__PURE__*/_react.default.createElement("button", {
    ref: control,
    type: "button",
    className: (0, _classnames.default)('playpause', {
      'playpause--play': status === PAUSED,
      'playpause--pause': status === PLAYING,
      'playpause--replay': status === ENDED
    }),
    onClick: toggle,
    "data-tip": "",
    "data-for": "playpause-tooltip"
  }));
};
/* eslint-disable react/no-unused-prop-types */


Playpause.propTypes = {
  videoTag: _propTypes.default.instanceOf(global.Element),
  callbacks: _propTypes.default.shape({
    onPlaypause: _propTypes.default.func
  }),
  toggleOnVideoClick: _propTypes.default.bool,
  onShortcutChange: _propTypes.default.func,
  texts: _propTypes.default.shape({
    play: _propTypes.default.string,
    pause: _propTypes.default.string,
    replay: _propTypes.default.string
  }),
  hasToolTip: _propTypes.default.bool
};
/* eslint-enable react/forbid-prop-types */

Playpause.defaultProps = {
  videoTag: null,
  callbacks: {
    onPlaypause: undefined
  },
  toggleOnVideoClick: false,
  onShortcutChange: () => {},
  texts: {
    play: 'Play (k)',
    pause: 'Pause (k)',
    replay: 'Replay (k)'
  },
  hasToolTip: false
};
var _default = Playpause;
exports.default = _default;